import React, { useEffect } from 'react';
import CheckCircle from "../../images/checkCircleNora.png"; 

const VerifyDone = () => {
  useEffect(() => {
    window.close();
  }, []);

  return (
    <div className="completionScreen">
          <div className="completion-content">
            <img src={CheckCircle} alt="Completion Check" className="nora-completion-icon" />

            <div className="nora-success-title">
                <h1> Your verification is complete! </h1>
                <p> You may now exit out of this browser. </p>
            </div>
          </div>
        </div>
  );
};

export default VerifyDone;